import { useEffect, useId } from "react";
import { IconX } from "../icons";

export default function AdminModal({
  open,
  onClose,
  title,
  description,
  children,
  footer,
  size = "md",
  layout,
  closeOnOverlay = true,
  showClose = true,
}) {
  const titleId = useId();
  const descriptionId = useId();

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("keydown", onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="admin-modal-overlay"
      onClick={closeOnOverlay ? onClose : undefined}
      role="presentation"
    >
      <div
        className={`admin-modal admin-modal--${size}${
          layout ? ` admin-modal--${layout}` : ""
        }`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={description ? descriptionId : undefined}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="admin-modal__header">
          <div className="admin-modal__header-text">
            <h2 id={titleId} className="admin-modal__title">
              {title}
            </h2>
            {description ? (
              <p id={descriptionId} className="admin-modal__description">
                {description}
              </p>
            ) : null}
          </div>
          {showClose ? (
            <button
              type="button"
              className="admin-modal__close"
              onClick={onClose}
              aria-label="Close"
            >
              <IconX size={18} />
            </button>
          ) : null}
        </div>

        {children ? <div className="admin-modal__body">{children}</div> : null}

        {footer ? <div className="admin-modal__footer">{footer}</div> : null}
      </div>
    </div>
  );
}
